import  { useEffect } from "react";
import "./secTwo.scss";
import { codeJourney, com, label, sec2, skills } from "../../data/MainData";
import arrowIcon from "../../assest/arrowIcon.webp";
import SocialMedia from "../../component/SocialMedia";
import PhotoLink from "../../component/PhotoLink";
import ContactDetails from "../../component/ConatctDetails";
import Aos from "aos";
import "aos/dist/aos.css";
import Pbutton from "../../component/PrimaryButton";



const SecTwo = () => {

    useEffect(() => {
      Aos.init({
        duration: 1000,       
        easing: "ease-out", 
        once: true,         
      });
    }, []);

  return (
    <div id="about">
      <div className="AboutContainer">
        <div className="AboutBackground"></div>

        <div className="AboutInner">
          <div className="AboutLeftSection">
            <h1 data-aos="fade-up">{sec2.title}</h1>
            
            <div className="card" data-aos="fade-up">
              <h2>{sec2.subTitle1}</h2>
                <br />
              <span>
                <h4>{sec2.sValue1}</h4>
                {sec2.statics1}
              </span>
              <span>
                <h4>{sec2.sValue2}</h4>
                {sec2.statics2}
              </span>
              <span>
                <h4>{sec2.sValue3}</h4>
                {sec2.statics3}
              </span>
              <br />
              <p>{sec2.aboutDes}</p>
              <br />
              <div>
                <SocialMedia />
              </div>
              <div>
                <Pbutton
                    label={label.btn_des2}
                    link = {label.links}
                />
              </div>
            </div>

            <div data-aos="fade-right">
              <PhotoLink />
            </div>

            <div data-aos="fade-up">
              <ContactDetails/>
            </div>
          </div>

          <div className="AboutRightSection">
            <div className="education" data-aos="fade-up">
              <h2>{sec2.subTitle2}</h2>
              <p>{sec2.education}</p>
              <br />
              <img className="arrow-img" src={arrowIcon} alt="" />
            </div>

            <div className="skills" data-aos="fade-up">
              <div>
                <h4>{sec2.subTitle5}</h4>
              </div>
              {skills.map((item, index) => {
                return <p key={index}>{item.skill}</p>;
              })}
            </div>

            <div className="codingJourney" data-aos="fade-up">
              <div className="card">
                <h2>{sec2.subTitle3}</h2>
                <br />
                {codeJourney.map((item, index) => (
                  <div key={index}>
                    <h3>{item.pos}</h3>
                    <p>{item.com}</p>
                    <br />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecTwo;
